import axios from "axios";

export const apiGetAgendaBill = async (id, client) => {
  try {
    const config = {
      headers: {
        Authorization: `Bearer ${process.env.NEXT_PUBLIC_AUTH_TOKEN}`,
      },
    };
    const result = await axios
      .get(
        `${process.env.NEXT_PUBLIC_SOCKET_URL}/api/agendabill/${id}?client=${client}`,
        config
      )
      .then(function (response) {
        if (response.status === 200) {
          const { data } = response;
          return data;
        } else {
          return null;
        }
      });
    return result;
  } catch (error) {
    console.log("error api agendaBill apiGetAgendaBill");
    console.log(error);
    return null;
  }
};

export const apiUpdateAgendaBill = async (id, data) => {
  try {
    const config = {
      headers: {
        Authorization: `Bearer ${process.env.NEXT_PUBLIC_AUTH_TOKEN}`,
      },
    };
    const result = await axios
      .patch(
        `${process.env.NEXT_PUBLIC_SOCKET_URL}/api/agendabill/${id}`,
        { ...data },
        config
      )
      .then(function (response) {
        if (response.status === 200) {
          const { data } = response;
          return data;
        } else {
          return null;
        }
      });
    return result;
  } catch (error) {
    console.log("error api agendaBill apiGetAgendaBill");
    console.log(error);
    return null;
  }
};
